import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import styled from 'styled-components';

const Container = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  width: 44px;
  height: 44px;
  border-radius: 100%;
  background-color: #fcf4f4;
  color: #c5443d;
  font-size: 16px;
  &.right {
    background-color: #f4f9ec;
    color: #669137;
  }
`;

const ResultIcon = ({ right }: { right?: boolean }) => {
  return (
    <Container className={right ? 'right' : ''}>
      {right ? <CheckOutlined /> : <CloseOutlined />}
    </Container>
  );
};

export default ResultIcon;
